// extracted by mini-css-extract-plugin
export default {"loadAction":"_27pBs","borderBottom":"_18PZK"};